'use client';
/** @jsxImportSource @emotion/react */

import { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiFormHelperText, {
  type FormHelperTextTypeMap as MuiFormHelperTextTypeMap,
} from '@mui/material/FormHelperText';

type ExcludedMuiProps = '';

type CustomProps = {
  component?: ElementType;
};

type FormHelperTextTypeMap<
  P = CustomProps,
  D extends ElementType = MuiFormHelperTextTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiFormHelperTextTypeMap['props'], ExcludedMuiProps> & P;
};

export type FormHelperTextProps<
  D extends ElementType = MuiFormHelperTextTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<MuiFormHelperTextTypeMap<P, D>, D>;

const FormHelperTextComponent = (
  props: FormHelperTextProps,
  ref: Ref<HTMLParagraphElement>
) => {
  return <MuiFormHelperText {...props} ref={ref} />;
};

FormHelperTextComponent.displayName = 'FormHelperText';

export const FormHelperText = forwardRef(
  FormHelperTextComponent
) as OverridableComponent<FormHelperTextTypeMap>;
